const SITE_URL = 'https://www.nimax.ru';

// JSON-LD не парсится как HTML — сущности вроде &nbsp; надо раскодировать до сериализации,
// иначе в структурированных данных окажется буквальный текст "&nbsp;"/"&mdash;".
const clean = str => (str ? str.replace(/&nbsp;/g, ' ').replace(/&mdash;/g, '—') : str);

/**
 * Собирает Service + BreadcrumbList для страницы услуги/департамента.
 * provider всегда ссылается на sitewide Organization (см. src/html.js), а не дублирует её.
 */
export function buildServiceSchema({ title, description, pageUrl, schemaData }) {
  const schemaTitle = clean(title) || '';

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: schemaTitle || undefined,
    serviceType: schemaTitle || undefined,
    description: clean(description) || undefined,
    url: pageUrl,
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: { '@type': 'Country', name: 'Россия' }
  };

  if (schemaData && schemaData['serviceList']) {
    serviceSchema.hasOfferCatalog = {
      '@type': 'OfferCatalog',
      name: schemaTitle || undefined,
      itemListElement: schemaData['serviceList'].map(item => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: clean(item['name']) || undefined
        }
      }))
    };
  }

  const breadcrumbItems =
    schemaData && schemaData['breadcrumbs']
      ? schemaData['breadcrumbs'].map((item, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: clean(item['name']) || undefined,
          item: item['url'] || undefined
        }))
      : [
          { '@type': 'ListItem', position: 1, name: 'Главная', item: `${SITE_URL}/` },
          { '@type': 'ListItem', position: 2, name: schemaTitle || undefined, item: pageUrl }
        ];

  return [
    serviceSchema,
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems
    }
  ];
}
